import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { Paragraph, Tel, Theme } from "@pga/pga-component-library"
import { flags, useFeatureFlags } from "../../lib/feature-flags"
import { redirectToMemberApplications } from "../../lib/ptmApplicationsRedirect"
import { useReapplyPathOffer } from "../../hooks/useReapplyPathOffer"
import BecomeAssociateModal from "../widgets/CourseCurriculum/BecomeAssociateModal"
import ReapplyPathOfferApplyActions from "./ApplyActions"
import ReapplyPathOfferStatuses from "./Statuses"

const MEMBERSHIP_NUMBER = "(800) 474-2776"

const Panel = styled.aside`
  width: 100%;
  padding: 16px;
  margin-bottom: 16px;
  background: ${Theme.colors.white};
  border-radius: 8px;
  outline: 1px solid ${Theme.colors.darkgrey};
  outline-offset: -1px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`

/**
 * Reapply Path Offer for PGM Progress Surfaces while Reapply-Gated.
 * Gated by account-terminated-notice; Apply CTAs still need PTM redirect.
 */
const ReapplyPathOfferPanel = ({ me, standing }) => {
  const [isTerminatedNoticeEnabled] =
    useFeatureFlags([flags.FLAG_FEAT_TERMINATED_NOTICE]) ?? []
  const [isBecomeAssociateModalOpen, setIsBecomeAssociateModalOpen] =
    useState(false)

  const enabled =
    !!isTerminatedNoticeEnabled && !!standing?.showReapplyPathOffer

  const { offer, associateApplication, affiliateApplication } =
    useReapplyPathOffer({ me, enabled })

  const showBecomeAssociateButton = Boolean(
    offer.associate?.showApplyCta && !offer.associate?.isResume,
  )

  useEffect(() => {
    if (!showBecomeAssociateButton) {
      setIsBecomeAssociateModalOpen(false)
    }
  }, [showBecomeAssociateButton])

  if (!enabled) {
    return null
  }

  return (
    <>
      <Panel role="region" aria-label="Reapply path offer">
        <Paragraph fw="normal" className="mb-0">
          Reapply to continue before purchasing or starting the next level.
        </Paragraph>
        <ReapplyPathOfferStatuses
          associateAction={offer.associate}
          affiliateAction={offer.affiliate}
          associateApplication={associateApplication}
          affiliateApplication={affiliateApplication}
        />
        {offer.isUnavailable ? (
          <Paragraph fw="normal" className="mb-0">
            Reapplication is not available online right now. Contact PGA
            Membership Services at <Tel phoneNumber={MEMBERSHIP_NUMBER} /> for
            help.
          </Paragraph>
        ) : null}
        <Actions>
          <ReapplyPathOfferApplyActions
            associateAction={offer.associate}
            affiliateAction={offer.affiliate}
            onBecomeAssociate={
              offer.associate?.isResume
                ? redirectToMemberApplications
                : () => setIsBecomeAssociateModalOpen(true)
            }
            onBecomeAffiliate={redirectToMemberApplications}
            className=""
          />
        </Actions>
      </Panel>
      <BecomeAssociateModal
        isOpen={isBecomeAssociateModalOpen}
        onClose={() => setIsBecomeAssociateModalOpen(false)}
        onApply={redirectToMemberApplications}
      />
    </>
  )
}

export default ReapplyPathOfferPanel
